import "core-js/modules/es.array.push.js";
export default {
  name: "PortalPasswordNotice",
  emits: ["close"],
  mounted() {
    this.previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    this.$nextTick(() => this.$refs.closeButton?.focus());
  },
  beforeUnmount() {
    document.body.style.overflow = this.previousBodyOverflow || "";
  },
  methods: {
    close() {
      this.$emit("close");
    },
    navigate(name) {
      this.close();
      if (this.$route.name !== name) this.$router.push({
        name
      });
    },
    onKeydown(event) {
      if (event.key === "Escape") {
        this.close();
        return;
      }
      if (event.key !== "Tab") return;
      const controls = [...this.$refs.dialog.querySelectorAll("button")];
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }
};